import React from 'react';
import PropTypes from 'prop-types';

/**
 * A reusable range slider component.
 */
const RangeSlider = ({min, max, step, value, onChange, className}) => {
  // compute 0–100%
  const percent = ((value - min) / (max - min)) * 100;

  return (
    <div className={`range-slider ${className}`}>
      <div
        className="range-slider__fill"
        style={{ width: `${percent}%` }}
      />
      <input
        type="range"
        className="range-slider__input"
        min={min}
        max={max}
        step={step}
        value={value}
        onChange={e => onChange(Number(e.target.value))}
      />
    </div>
  );
};


RangeSlider.propTypes = {
  /** Minimum value */
  min: PropTypes.number,
  /** Maximum value */
  max: PropTypes.number,
  /** Step increment */
  step: PropTypes.number,
  /** Current value */
  value: PropTypes.number.isRequired,
  /** Change handler receives the new numeric value */
  onChange: PropTypes.func.isRequired,
  /** Optional custom class for styling */
  className: PropTypes.string
};

RangeSlider.defaultProps = {
  min: 0,
  max: 100,
  step: 1,
  className: ''
};

export default RangeSlider;